/** Pretty-print audit old/new values for CSV / display. */
export function formatAuditDetailValue(value) {
  if (value == null || value === "") {
    return "";
  }
  if (typeof value === "object") {
    try {
      return JSON.stringify(value);
    } catch {
      return String(value);
    }
  }
  const text = String(value);
  try {
    return JSON.stringify(JSON.parse(text));
  } catch {
    return text;
  }
}

export function buildAuditCsvRows(logs, formatTimestamp) {
  const headers = [
    "Timestamp",
    "What changed",
    "Page / Area",
    "User",
    "Action",
    "Record ID",
    "IP Address",
    "Previous value",
    "New value",
  ];

  const rows = (logs || []).map((log) => [
    formatTimestamp(log.created_at),
    log.summary ||
      `${log.action || ""} ${log.page_label || log.table_name || ""} ${log.record_id != null ? "#" + log.record_id : ""}`.trim(),
    log.page_label || log.table_name || "N/A",
    log.user_name || "System",
    log.action || "",
    log.record_id != null ? String(log.record_id) : "N/A",
    log.ip_address || "",
    formatAuditDetailValue(log.old_values),
    formatAuditDetailValue(log.new_values),
  ]);

  return { headers, rows };
}

export function toCsvContent(headers, rows) {
  return [
    headers.join(","),
    ...rows.map((row) =>
      row.map((cell) => `"${String(cell).replace(/"/g, '""')}"`).join(","),
    ),
  ].join("\n");
}
